module.exports = __webpack_public_path__ + "img/s1.2aec1b78.png";